import React from 'react';
import './Tip.less';

import {Minibutton} from 'elements/minibutton/Minibutton.tsx';
import {MinibuttonGroup} from '../minibutton-group/MinibuttonGroup';

export const Tip = ({percents = [], selectedPercent, onPercentClick}) => {
	return (
		<MinibuttonGroup>
			{percents.map(percent => (
				<Minibutton
					key={percent}
					text={`${percent}%`}
					isPressed={percent === selectedPercent}
					onClick={() => onPercentClick(percent === selectedPercent ? 0 : percent)}
				/>
			))}
		</MinibuttonGroup>
	);
};
